import React from 'react';
function Date({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.707 5H5.293C4.58 5 4 5.656 4 6.466v12.068C4 19.344 4.58 20 5.293 20h13.414C19.42 20 20 19.344 20 18.534V6.466C20 5.656 19.42 5 18.707 5zM4 9h16M6.6 12.89h10M6.6 15.555h6M7.5 3v2.667M16.5 3v2.667"
      />
    </svg>
  );
}

export default Date;
